import { Truck } from 'react-feather'
import { Expose, Transform, Type } from 'class-transformer'
import moment from 'moment'

import { Appointment } from './Appointment'
import { ASN } from './ASN'
import { Dock } from './Dock'
import { Driver } from './Driver'
import { Facility } from './Facility'

export enum DriverVisitStatus {
  checkedIn = 'checked_in',
  assigned = 'assigned',
  docked = 'docked',
  rejected = 'rejected',
}

export class DriverVisit {
  static type = 'drivervisit'
  static typeDisplay = 'Driver Visit'
  static icon = Truck

  static Status = DriverVisitStatus

  type = DriverVisit.type
  typeDisplay = DriverVisit.typeDisplay
  icon = DriverVisit.icon

  guid: string = ''

  status?: DriverVisitStatus

  @Type(() => Facility)
  facility?: Facility

  @Type(() => Driver)
  driver?: Driver

  @Expose({ name: 'checked_in_on' })
  @Transform((value) => value ? moment(value) : value)
  checkedInOn?: moment.Moment

  @Type(() => ASN)
  asn?: ASN

  @Expose({ name: 'assigned_dock' })
  @Type(() => Dock)
  assignedDock?: Dock

  @Expose({ name: 'assigned_appointment' })
  @Type(() => Appointment)
  assignedAppointment?: Appointment

  @Expose({ name: 'created_on' })
  @Transform((value) => value ? moment(value) : value)
  createdOn: moment.Moment = moment()

  @Expose({ name: 'updated_on' })
  @Transform((value) => value ? moment(value) : value)
  updatedOn: moment.Moment = moment()

  get name() {
    return `${this.driver?.fullName}: ${this.facility?.name} (${this.checkedInOn?.toLocaleString()})`
  }
}
